.menuContainer {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	overflow: hidden;
}

/* Delete on FF cleanup of: list-view-add-dependency-styling-fix_9ibdi */
.addDependencyIssueSelector {
	flex: 1 0 auto;
}
